import type { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { LoadingCell } from '@mint-lib/ag-grid/components';
import { TruncateText, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

const TextCell = ({ data, value }: ICellRendererParams) => {
  if (!data) {
    return <LoadingCell />;
  }

  const text = value == null ? '' : String(value);

  return (
    <div className="flex h-full min-w-0 items-center">
      <TruncateText>
        <div
          className={cn(
            typographyVariants({ variant: 'bodyShort01', color: 'primary' }),
            'block',
          )}
        >
          {text}
        </div>
      </TruncateText>
    </div>
  );
};

export default TextCell;
